import React from 'react';
import styled from 'styled-components';
import Modal from 'react-awesome-modal'
import Loader from 'react-loader';
import { toast } from 'react-toastify';

import { PROXIED_MEDIABASE } from '../../../../common/constants'
import Handle from '../Handle/Handle.Component';

import { ModalContent } from '../EditModal/Modal.styles';
import { sampleImages } from '../../../../assets/images/lessonbuilder/images';
import withServices from 'src/HOCs/withServices';


const StyledImgInput = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 200px;
    width: 100%;
    border: 2px solid rgba(255, 255, 255, .2);
    border-radius: 5px;
`

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    height: 150px;
    width: 100%;

    input, select, img {
        width: 33%;
        margin-right: 4px;
    }
`

const ImagesContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    height: 540px;
    overflow-y: scroll;
    align-content: flex-start;
    width: 90%;
    img{
        max-width: 100px;
        height: 60px;
        padding: 4px;
    }
`

const Button = styled.button`
    display: ${props => props.show ? 'block     ' : 'none'} ;
    height: 40px;
    width: 90%;
    border-radius: 5px;
    border: 2px #fff solid;
    background-color: rgba(255, 255, 255, .2);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;
`

class IconInput extends React.Component {
    state = {
        modalOpen: false,
        showEdit: false,
        images: null,
        imagesLoaded: false,
        imgCollections: null,
        collectionsLoaded: false,
    }
    constructor(props) {
        super(props);

        this.chooseImgCollectionHandler = this.chooseImgCollectionHandler.bind(this);
    }

    async componentDidMount() {
        const { services: { adminAPI } } = this.props;
        const res = await adminAPI.getAssetCollections();

        if (res.ok) {
            this.setState({ imgCollections: res.data, collectionsLoaded: true });
        }
    }


    toggleEditButtons = () => {
        const { showEdit } = this.state;
        this.setState({ showEdit: !showEdit });
    }

    toggleModal = () => {
        const { modalOpen } = this.state;
        this.setState({ modalOpen: !modalOpen });
    }
    openModal = () => {
        this.setState({ modalOpen: true });
        // query for images
        const images = sampleImages.images;
        this.setState({ images });
    }
    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    closeModalHandler = (colIdx, value) => {
        this.props.selectIcon(colIdx, `${PROXIED_MEDIABASE}assets/${value}`);
        this.setState({ modalOpen: false });
    }

    changeAlign = (event) => {
        // pass columnIndex, property to change, value to change to
        const value = event.target.value;
        this.props.changeStyleProperty(this.props.columnIndex, 'align', value);
    }

    changeWidth = (event) => {
        const value = event.target.value;
        this.props.changeStyleProperty(this.props.columnIndex, 'size', value);
    }
    deleteAsset = () => {
        this.props.deleteAsset(this.props.columnIndex);
    }

    async chooseImgCollectionHandler(event) {
        this.setState({ imagesLoaded: false });
        const res = await this.props.services.adminAPI.getCollectionItems(+event.target.value);
        if (res.ok) {
            const images = res.data.assets;
            console.log("IconRes: " + JSON.stringify(res.data, null, 2));
            this.setState({ images, imagesLoaded: true });
        } else {
            toast.error("Images Not Found!");
        }
    }
    renderCollectionOptions = () => {
        const { collectionsLoaded, imgCollections } = this.state;
        if (collectionsLoaded) {
            return (
                <select style={{ width: "80%" }} className="custom-select" onChange={this.chooseImgCollectionHandler}>
                    <option value="">-- Choose an Asset Collection --</option>
                    {imgCollections.map(collection => {
                        return <option key={`imgcollection${collection.AssetCollectionId}`} value={collection.AssetCollectionId}>{collection.Name} : {collection.Description}</option>
                    })}
                </select>
            )
        } else {
            return <Loader color="#acff2430" />
        }
    }

    renderImagesContainer = () => {
        const { images, imagesLoaded } = this.state;
        if (imagesLoaded) {
            return (
                <React.Fragment>
                    <p style={{ color: "white" }}>Choose An Icon Here!</p>
                    <ImagesContainer>
                        {images.map((img, idx) => {
                            return <img key={idx} src={`${PROXIED_MEDIABASE}assets/${img.FileName}`} onClick={this.closeModalHandler.bind(this, this.props.columnIndex, img.FileName)} />
                        })}
                    </ImagesContainer>
                </React.Fragment>

            )
        } else {
            return <p style={{ color: "#fff", font: "italic bold 18px 'Roboto" }}>Please choose an Image Collection First</p>
        }
    }


    render() {
        const { images } = this.state;

        return (
            <StyledImgInput>
                <Modal visible={this.state.modalOpen} width="900" height="600" effect="fadeInUp" onClickAway={() => this.closeModal()}>
                    <ModalContent>
                        {this.renderCollectionOptions()}
                        {this.renderImagesContainer()}
                    </ModalContent>
                </Modal>
                <Handle type="ICON" deleteAsset={this.deleteAsset} />
                <ContentWrapper>
                    <input className="custom-textfield lb-textfield" type="number" name="width" id="width" onChange={this.changeWidth} placeholder={this.props.size} />
                    <select className="custom-select lb-select" name="" id="" onChange={this.changeAlign}>
                        <option selected={this.props.alignment === "center"} value="center">Center</option>
                        <option selected={this.props.alignment === "left"} value="left">Left</option>
                        <option selected={this.props.alignment === "right"} value="right">Right</option>
                    </select>
                    <div onMouseEnter={this.toggleEditButtons} onMouseLeave={this.toggleEditButtons} >
                        <img style={{ width: '60px' }} src={this.props.url} alt="Add Image" />

                        <Button show={this.state.showEdit} onClick={this.openModal}>Edit</Button>

                    </div>
                </ContentWrapper>
            </StyledImgInput>
        )
    }
}

export default withServices(IconInput);


// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/IconInput/IconInput.Component.jsx